// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product glimpses on the sign-in brand panel.
   Tokens come from EmailForm.css; everything here is scoped to .glimpse. */

.glimpse {
  width: 100%;
  max-width: 520px;
  margin-top: 34px;
}

.glimpse-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin: 0 0 14px;
}

.glimpse-name {
  font-family: var(--snoh-display);
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
}

.glimpse-does {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.58);
}

/* Fixed height so swapping products never moves the panel */
.glimpse-stage {
  position: relative;
  height: 274px;
}

.glimpse-slide {
  position: absolute;
  inset: 0;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(3px);
  animation: g-slide-in 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
  overflow: hidden;
}

@keyframes g-slide-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
}

.glimpse-dots {
  display: flex;
  gap: 8px;
  margin: 18px 0 0;
}

.glimpse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.28);
  transition: background-color 0.3s ease, width 0.3s ease;
}

.glimpse-dot.is-on {
  width: 22px;
  border-radius: 3.5px;
  background: var(--snoh-orange-light);
}

/* ---------- Shared pieces ---------- */

.glimpse .is-on,
.glimpse .g-scan,
.glimpse .g-card,
.glimpse .g-result,
.glimpse .g-field,
.glimpse .g-check,
.glimpse .g-cite,
.glimpse .g-msg--answer,
.glimpse .g-box {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.glimpse .g-scan,
.glimpse .g-card,
.glimpse .g-result,
.glimpse .g-field,
.glimpse .g-check,
.glimpse .g-cite,
.glimpse .g-msg--answer {
  opacity: 0;
  transform: translateY(6px);
}

.glimpse .g-scan.is-on,
.glimpse .g-card.is-on,
.glimpse .g-result.is-on,
.glimpse .g-field.is-on,
.glimpse .g-check.is-on,
.glimpse .g-cite.is-on,
.glimpse .g-msg--answer.is-on {
  opacity: 1;
  transform: none;
}

.g-live {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #63d68a;
  box-shadow: 0 0 0 3px rgba(99, 214, 138, 0.2);
}

.g-tick {
  width: 14px;
  height: 14px;
  flex: none;
  fill: none;
  stroke: #7fd6ff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.g-result {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.78);
}

/* ---------- Snoh Docs ---------- */

.g-docs {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.g-searchbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 11px;
  background: rgba(6, 25, 60, 0.45);
}

.g-search-ico {
  width: 15px;
  height: 15px;
  flex: none;
  fill: none;
  stroke: rgba(255, 255, 255, 0.6);
  stroke-width: 1.6;
  stroke-linecap: round;
}

.g-q {
  font-size: 13.5px;
  line-height: 1.35;
  color: #ffffff;
}

.g-caret {
  display: inline-block;
  width: 1.5px;
  height: 13px;
  margin-left: 1px;
  vertical-align: -1px;
  background: var(--snoh-orange-light);
  animation: g-blink 1s steps(1) infinite;
}

@keyframes g-blink {
  50% {
    opacity: 0;
  }
}

.g-scan {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.g-card {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.07);
}

.g-badge {
  flex: none;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #ffffff;
  background: rgba(233, 98, 15, 0.75);
}

.g-card-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-right: auto;
}

.g-card-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.g-card-path {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55);
}

/* Sits at the foot of the card so the taller stage has no dead space */
.g-docs .g-result {
  margin-top: auto;
}

.g-ver {
  flex: none;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.7);
}

/* ---------- Snoh Fusion ---------- */

.g-fusion {
  display: grid;
  grid-template-columns: 40% 1fr;
  gap: 15px;
  height: 100%;
}

.g-doc {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 13px;
  overflow: hidden;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
}

.g-doc-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #0e1a2b;
}

.g-doc-sub {
  font-size: 10px;
  color: #5c6e88;
}

.g-doc-bar {
  height: 5px;
  border-radius: 2.5px;
  background: #d5dee9;
}

.g-doc-total {
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid #d5dee9;
  font-size: 11px;
  font-weight: 700;
  color: #0e1a2b;
}

.g-doc-sweep {
  position: absolute;
  left: 0;
  right: 0;
  height: 42px;
  background: linear-gradient(
    180deg,
    rgba(15, 111, 212, 0) 0%,
    rgba(15, 111, 212, 0.28) 50%,
    rgba(15, 111, 212, 0) 100%
  );
  animation: g-sweep 2.6s ease-in-out infinite;
}

@keyframes g-sweep {
  from {
    top: -42px;
  }
  to {
    top: 100%;
  }
}

.g-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.g-fields-top {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 2px;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.6);
}

.g-fields-top b {
  margin-left: auto;
  font-size: 11.5px;
  color: #ffffff;
}

.g-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 9px 12px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.06);
}

.g-field-k {
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.55);
}

.g-field-v {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
}

/* ---------- Snoh Ava ---------- */

.g-ava {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.g-msg {
  margin: 0;
  padding: 11px 14px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.45;
}

.g-msg--ask {
  align-self: flex-end;
  max-width: 88%;
  color: #ffffff;
  background: rgba(233, 98, 15, 0.28);
  border: 1px solid rgba(255, 154, 77, 0.35);
}

.g-msg--answer {
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.g-msg--answer sup {
  margin-left: 2px;
  font-size: 9.5px;
  color: var(--snoh-orange-light);
}

.g-check {
  margin: 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55);
}

.g-cite {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: auto 0 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.68);
}

.g-cite-n {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  flex: none;
  border-radius: 5px;
  font-size: 10.5px;
  font-weight: 700;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
}

/* ---------- Snoh Flow ---------- */

.g-flow {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.g-flow-top {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.6);
}

.g-run {
  margin-left: auto;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.8);
}

.g-req {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.g-req-title {
  font-family: var(--snoh-display);
  font-size: 15.5px;
  font-weight: 600;
  color: #ffffff;
}

.g-req-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--snoh-orange-light);
}

.g-req-meta {
  margin: -5px 0 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55);
}

.g-rail {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  /* Spread the five steps down the card rather than bunching at the top */
  flex: 1 1;
  justify-content: space-between;
  gap: 9px;
}

.g-rail li {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.4s ease;
}

.g-rail li.is-on {
  color: rgba(255, 255, 255, 0.92);
}

.g-rail-dot {
  width: 10px;
  height: 10px;
  flex: none;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.35);
  transition: background-color 0.4s ease, border-color 0.4s ease,
    box-shadow 0.4s ease;
}

.g-rail li.is-on .g-rail-dot {
  border-color: #63d68a;
  background: #63d68a;
  box-shadow: 0 0 0 3px rgba(99, 214, 138, 0.18);
}

/* ---------- Snoh Vision ---------- */

.g-vision {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.g-frame {
  position: relative;
  flex: 1 1;
  overflow: hidden;
  border-radius: 11px;
  background: linear-gradient(158deg, #0b2a55 0%, #071c3f 100%);
}

.g-frame-label {
  position: absolute;
  top: 11px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
}

.g-box {
  position: absolute;
  border: 1.5px solid var(--snoh-orange-light);
  border-radius: 5px;
  opacity: 0;
  transform: scale(0.94);
}

.g-box.is-on {
  opacity: 1;
  transform: none;
}

.g-box i {
  position: absolute;
  top: -18px;
  left: -1.5px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-style: normal;
  white-space: nowrap;
  color: #ffffff;
  background: var(--snoh-orange);
}

.g-box--one {
  top: 56px;
  left: 44px;
  width: 84px;
  height: 66px;
}

.g-box--two {
  top: 88px;
  right: 52px;
  width: 114px;
  height: 58px;
}

.g-frame-sweep {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 52px;
  background: linear-gradient(
    90deg,
    rgba(127, 214, 255, 0) 0%,
    rgba(127, 214, 255, 0.14) 50%,
    rgba(127, 214, 255, 0) 100%
  );
  animation: g-frame-sweep 3.4s ease-in-out infinite;
}

@keyframes g-frame-sweep {
  from {
    left: -52px;
  }
  to {
    left: 100%;
  }
}

/* ---------- Narrower panels ---------- */

@media (max-width: 1200px) {
  .glimpse {
    max-width: 440px;
  }

  .glimpse-stage {
    height: 248px;
  }
}

@media (max-width: 1024px) {
  .glimpse {
    max-width: 400px;
    margin-top: 24px;
  }

  .glimpse-stage {
    height: 224px;
  }
}

@media (max-width: 880px) {
  .glimpse {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .glimpse-slide,
  .g-caret,
  .g-doc-sweep,
  .g-frame-sweep {
    animation: none;
  }

  .glimpse .g-scan,
  .glimpse .g-card,
  .glimpse .g-result,
  .glimpse .g-field,
  .glimpse .g-check,
  .glimpse .g-cite,
  .glimpse .g-msg--answer,
  .glimpse .g-box {
    transition: none;
  }

  .g-doc-sweep,
  .g-frame-sweep {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductGlimpse.css"],"names":[],"mappings":"AAAA;2EAC2E;;AAE3E;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA,wCAAwC;;AAExC;;;;;;;;;EASE,oDAAoD;AACtD;;AAEA;;;;;;;EAOE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ;;;;;GAKC;EACD,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,wEAAwE;EACxE,SAAO;EACP,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C;wBACsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX;;;;;GAKC;EACD,kDAAkD;AACpD;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,0CAA0C;;AAE1C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;;;;;;;;IAQE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Product glimpses on the sign-in brand panel.\n   Tokens come from EmailForm.css; everything here is scoped to .glimpse. */\n\n.glimpse {\n  width: 100%;\n  max-width: 520px;\n  margin-top: 34px;\n}\n\n.glimpse-head {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  margin: 0 0 14px;\n}\n\n.glimpse-name {\n  font-family: var(--snoh-display);\n  font-size: 17px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.glimpse-does {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.58);\n}\n\n/* Fixed height so swapping products never moves the panel */\n.glimpse-stage {\n  position: relative;\n  height: 274px;\n}\n\n.glimpse-slide {\n  position: absolute;\n  inset: 0;\n  padding: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(3px);\n  animation: g-slide-in 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n  overflow: hidden;\n}\n\n@keyframes g-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n}\n\n.glimpse-dots {\n  display: flex;\n  gap: 8px;\n  margin: 18px 0 0;\n}\n\n.glimpse-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.28);\n  transition: background-color 0.3s ease, width 0.3s ease;\n}\n\n.glimpse-dot.is-on {\n  width: 22px;\n  border-radius: 3.5px;\n  background: var(--snoh-orange-light);\n}\n\n/* ---------- Shared pieces ---------- */\n\n.glimpse .is-on,\n.glimpse .g-scan,\n.glimpse .g-card,\n.glimpse .g-result,\n.glimpse .g-field,\n.glimpse .g-check,\n.glimpse .g-cite,\n.glimpse .g-msg--answer,\n.glimpse .g-box {\n  transition: opacity 0.45s ease, transform 0.45s ease;\n}\n\n.glimpse .g-scan,\n.glimpse .g-card,\n.glimpse .g-result,\n.glimpse .g-field,\n.glimpse .g-check,\n.glimpse .g-cite,\n.glimpse .g-msg--answer {\n  opacity: 0;\n  transform: translateY(6px);\n}\n\n.glimpse .g-scan.is-on,\n.glimpse .g-card.is-on,\n.glimpse .g-result.is-on,\n.glimpse .g-field.is-on,\n.glimpse .g-check.is-on,\n.glimpse .g-cite.is-on,\n.glimpse .g-msg--answer.is-on {\n  opacity: 1;\n  transform: none;\n}\n\n.g-live {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #63d68a;\n  box-shadow: 0 0 0 3px rgba(99, 214, 138, 0.2);\n}\n\n.g-tick {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  fill: none;\n  stroke: #7fd6ff;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.g-result {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n/* ---------- Snoh Docs ---------- */\n\n.g-docs {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n}\n\n.g-searchbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 11px;\n  background: rgba(6, 25, 60, 0.45);\n}\n\n.g-search-ico {\n  width: 15px;\n  height: 15px;\n  flex: none;\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.6);\n  stroke-width: 1.6;\n  stroke-linecap: round;\n}\n\n.g-q {\n  font-size: 13.5px;\n  line-height: 1.35;\n  color: #ffffff;\n}\n\n.g-caret {\n  display: inline-block;\n  width: 1.5px;\n  height: 13px;\n  margin-left: 1px;\n  vertical-align: -1px;\n  background: var(--snoh-orange-light);\n  animation: g-blink 1s steps(1) infinite;\n}\n\n@keyframes g-blink {\n  50% {\n    opacity: 0;\n  }\n}\n\n.g-scan {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.g-card {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 13px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 11px;\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.g-badge {\n  flex: none;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #ffffff;\n  background: rgba(233, 98, 15, 0.75);\n}\n\n.g-card-text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-right: auto;\n}\n\n.g-card-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.g-card-path {\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n/* Sits at the foot of the card so the taller stage has no dead space */\n.g-docs .g-result {\n  margin-top: auto;\n}\n\n.g-ver {\n  flex: none;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* ---------- Snoh Fusion ---------- */\n\n.g-fusion {\n  display: grid;\n  grid-template-columns: 40% 1fr;\n  gap: 15px;\n  height: 100%;\n}\n\n.g-doc {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  padding: 13px;\n  overflow: hidden;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.g-doc-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #0e1a2b;\n}\n\n.g-doc-sub {\n  font-size: 10px;\n  color: #5c6e88;\n}\n\n.g-doc-bar {\n  height: 5px;\n  border-radius: 2.5px;\n  background: #d5dee9;\n}\n\n.g-doc-total {\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px solid #d5dee9;\n  font-size: 11px;\n  font-weight: 700;\n  color: #0e1a2b;\n}\n\n.g-doc-sweep {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 42px;\n  background: linear-gradient(\n    180deg,\n    rgba(15, 111, 212, 0) 0%,\n    rgba(15, 111, 212, 0.28) 50%,\n    rgba(15, 111, 212, 0) 100%\n  );\n  animation: g-sweep 2.6s ease-in-out infinite;\n}\n\n@keyframes g-sweep {\n  from {\n    top: -42px;\n  }\n  to {\n    top: 100%;\n  }\n}\n\n.g-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.g-fields-top {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0 0 2px;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.g-fields-top b {\n  margin-left: auto;\n  font-size: 11.5px;\n  color: #ffffff;\n}\n\n.g-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 9px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.g-field-k {\n  font-size: 10.5px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.g-field-v {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n/* ---------- Snoh Ava ---------- */\n\n.g-ava {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 100%;\n}\n\n.g-msg {\n  margin: 0;\n  padding: 11px 14px;\n  border-radius: 12px;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.g-msg--ask {\n  align-self: flex-end;\n  max-width: 88%;\n  color: #ffffff;\n  background: rgba(233, 98, 15, 0.28);\n  border: 1px solid rgba(255, 154, 77, 0.35);\n}\n\n.g-msg--answer {\n  color: rgba(255, 255, 255, 0.9);\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n}\n\n.g-msg--answer sup {\n  margin-left: 2px;\n  font-size: 9.5px;\n  color: var(--snoh-orange-light);\n}\n\n.g-check {\n  margin: 0;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.g-cite {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: auto 0 0;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.g-cite-n {\n  display: grid;\n  place-items: center;\n  width: 18px;\n  height: 18px;\n  flex: none;\n  border-radius: 5px;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.16);\n}\n\n/* ---------- Snoh Flow ---------- */\n\n.g-flow {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 100%;\n}\n\n.g-flow-top {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.g-run {\n  margin-left: auto;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.g-req {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.g-req-title {\n  font-family: var(--snoh-display);\n  font-size: 15.5px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.g-req-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--snoh-orange-light);\n}\n\n.g-req-meta {\n  margin: -5px 0 0;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.g-rail {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  /* Spread the five steps down the card rather than bunching at the top */\n  flex: 1;\n  justify-content: space-between;\n  gap: 9px;\n}\n\n.g-rail li {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.4);\n  transition: color 0.4s ease;\n}\n\n.g-rail li.is-on {\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.g-rail-dot {\n  width: 10px;\n  height: 10px;\n  flex: none;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  transition: background-color 0.4s ease, border-color 0.4s ease,\n    box-shadow 0.4s ease;\n}\n\n.g-rail li.is-on .g-rail-dot {\n  border-color: #63d68a;\n  background: #63d68a;\n  box-shadow: 0 0 0 3px rgba(99, 214, 138, 0.18);\n}\n\n/* ---------- Snoh Vision ---------- */\n\n.g-vision {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n}\n\n.g-frame {\n  position: relative;\n  flex: 1;\n  overflow: hidden;\n  border-radius: 11px;\n  background: linear-gradient(158deg, #0b2a55 0%, #071c3f 100%);\n}\n\n.g-frame-label {\n  position: absolute;\n  top: 11px;\n  left: 12px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.g-box {\n  position: absolute;\n  border: 1.5px solid var(--snoh-orange-light);\n  border-radius: 5px;\n  opacity: 0;\n  transform: scale(0.94);\n}\n\n.g-box.is-on {\n  opacity: 1;\n  transform: none;\n}\n\n.g-box i {\n  position: absolute;\n  top: -18px;\n  left: -1.5px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-style: normal;\n  white-space: nowrap;\n  color: #ffffff;\n  background: var(--snoh-orange);\n}\n\n.g-box--one {\n  top: 56px;\n  left: 44px;\n  width: 84px;\n  height: 66px;\n}\n\n.g-box--two {\n  top: 88px;\n  right: 52px;\n  width: 114px;\n  height: 58px;\n}\n\n.g-frame-sweep {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 52px;\n  background: linear-gradient(\n    90deg,\n    rgba(127, 214, 255, 0) 0%,\n    rgba(127, 214, 255, 0.14) 50%,\n    rgba(127, 214, 255, 0) 100%\n  );\n  animation: g-frame-sweep 3.4s ease-in-out infinite;\n}\n\n@keyframes g-frame-sweep {\n  from {\n    left: -52px;\n  }\n  to {\n    left: 100%;\n  }\n}\n\n/* ---------- Narrower panels ---------- */\n\n@media (max-width: 1200px) {\n  .glimpse {\n    max-width: 440px;\n  }\n\n  .glimpse-stage {\n    height: 248px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .glimpse {\n    max-width: 400px;\n    margin-top: 24px;\n  }\n\n  .glimpse-stage {\n    height: 224px;\n  }\n}\n\n@media (max-width: 880px) {\n  .glimpse {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .glimpse-slide,\n  .g-caret,\n  .g-doc-sweep,\n  .g-frame-sweep {\n    animation: none;\n  }\n\n  .glimpse .g-scan,\n  .glimpse .g-card,\n  .glimpse .g-result,\n  .glimpse .g-field,\n  .glimpse .g-check,\n  .glimpse .g-cite,\n  .glimpse .g-msg--answer,\n  .glimpse .g-box {\n    transition: none;\n  }\n\n  .g-doc-sweep,\n  .g-frame-sweep {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
